export const ICON_RIGHT = 'right'; // most right position
export const ICON_LEFT = 'left'; // most left position
export const ICON_NONE = 'none'; // no icon
export const iconVariants = [ICON_RIGHT, ICON_LEFT, ICON_NONE];
//# sourceMappingURL=types.js.map